"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectionEnum = void 0;
var DirectionEnum;
(function (DirectionEnum) {
    DirectionEnum["InBound"] = "I";
    DirectionEnum["Outbound"] = "O";
    DirectionEnum["Internal"] = "-";
})(DirectionEnum = exports.DirectionEnum || (exports.DirectionEnum = {}));
